/** @format */

import { Paper, Typography, Skeleton, Stack } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const MessageRecord = ({ sentAt, text, type }) => {
  return (
    <Paper
      sx={{
        p: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
      elevation={5}
    >
      <Typography variant="body2" component="div" sx={{ mx: 2 }}>
        {type || 'Type'}
      </Typography>
      <Typography variant="h6" component="div">
        {dayjs(sentAt).format('MM/DD/YYYY HH:mm')}
      </Typography>
      <Typography
        component="div"
        variant="body2"
        color="text.secondary"
        align="center"
        title={text}
        sx={{
          maxWidth: '50vw',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          mt: 1,
        }}
      >
        {text.substring(0, 60) + '...'}
      </Typography>
    </Paper>
  );
};

const MessageHistoryRecord = ({
  pilotsMessages,
  voucherMessages,
  flightId,
}) => {
  return (
    <>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 'fit-content',
          maxWidth: 'fit-content',
        }}
        elevation={10}
      >
        <Typography variant="h4" component="div">
          {flightId}
        </Typography>
        <Typography variant="h6" component="div">
          Customer Messages
        </Typography>

        <Stack spacing={2} overflow={'scroll'} p={2}>
          {pilotsMessages.map((message) => (
            <MessageRecord
              key={message._id}
              sentAt={message.sentAt}
              text={message.text}
              type={message.type}
            />
          ))}
        </Stack>
        <Typography variant="h6" component="div">
          Voucher Messages
        </Typography>
        <Stack spacing={2} overflow={'scroll'} p={2}>
          {voucherMessages.map((message) => (
            <MessageRecord
              key={message._id}
              sentAt={message.sentAt}
              text={message.text}
            />
          ))}
        </Stack>
      </Paper>
    </>
  );
};

export default MessageHistoryRecord;
